/**
 * digitvision
 *
 * @category  digitvision
 * @package   Shopware\Plugins\DvsnFormBuilder
 * @copyright (c) 2026 digitvision
 */

import template from './dvsn-form-builder-form-list.html.twig';

const { Component, Mixin } = Shopware;
const { Criteria } = Shopware.Data;

Component.register('dvsn-form-builder-form-list', {
    template,

    inject: [
        'repositoryFactory',
        'dvsnFormBuilderInAppService'
    ],

    mixins: [
        Mixin.getByName('notification'),
        Mixin.getByName('listing')
    ],

    data() {
        return {
            forms: null,
            isLoading: true,
        };
    },

    metaInfo() {
        return {
            title: this.$createTitle()
        };
    },

    computed: {
        columns() {
            return this.getColumns();
        },

        repository() {
            return this.getRepository();
        },

        dateFilter() {
            return Shopware.Filter.getByName('date');
        },

        countForms() {
            if (this.isLoading === true) {
                return 0;
            }

            return this.forms.total;
        },

        planLimitReached() {
            if (this.isLoading === true) {
                return true;
            }

            return this.dvsnFormBuilderInAppService.isPlanLimitReached(this.countForms);
        }
    },

    methods: {
        getColumns() {
            return [{
                property: 'name',
                dataIndex: 'name',
                label: this.$t('dvsn-form-builder-form.list.column-name'),
                allowResize: true
            }, {
                property: 'createdAt',
                dataIndex: 'createdAt',
                label: this.$t('dvsn-form-builder-form.list.column-created-at'),
                allowResize: true
            }];
        },

        getRepository() {
            return this.repositoryFactory.create('dvsn_form_builder_form');
        },

        getList() {
            this.isLoading = true;

            const criteria = new Criteria(this.page, this.limit);
            criteria
                .addSorting(Criteria.sort('createdAt', 'ASC'));
            criteria.setTerm(this.term);

            this.repository
                .search(criteria, Shopware.Context.api)
                .then((result) => {
                    this.forms = result;
                    this.isLoading = false;
                });
        },
    },

    created() {
    }
});
